<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import pieChart from "./pieChart";
import Director from '../dashboard/director.vue';
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader,pieChart,Director },
    data() {
        return {
            title: "Starter Page",
            items: [
                {
                text: "Utility",
                href: "/"
                },
                {
                text: "Starter Page",
                active: true
                }
            ],
            filtro:{
                colegio:''
            },
            colegios:[]
        };
    },
    methods:{
        actualizar(){
            if (this.user.rol_id==1) {
                axios.get('/api/get_colegios').then(res=>{
                    this.colegios = res.data.colegios;
                });
            }
            else if (this.user.rol_id==2) {
                this.filtro.colegio=this.user.colegio_id;
                //this.buscar();
            }
        },
    },
    created(){
        this.actualizar();
    }
};
</script>
<template>
    <Layout>
        <PageHeader  :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <!-- <div class="row">
                            <div class="col-md-12">
                                <b-button class="float-right ml-2" variant="primary" href="/app/agregar/usuarios">Usuarios</b-button>
                            </div>
                        </div> -->
                        <div class="card p-3 mt-2 bg-soft-primary" v-if="user.rol_id==1">
                            <div class="row">
                                <div class="offset-md-2 col-md-6">
                                    <div class="form-group row">
                                        <label class="col-md-3 pt-1 font-size-16 text-right">Colegio :</label>
                                        <div class="col-md-9">
                                            <select class="custom-select" v-model="filtro.colegio">
                                                <option selected value="">Seleccione colegio</option>
                                                <option v-for="colegio in colegios" :key="colegio.id" :value="colegio.id">{{colegio.nombre.toUpperCase()}}-{{colegio.comuna_nombre}}-{{colegio.region_nombre}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-md-2 text-right">
                                    <b-button variant="primary" block @click="buscar()">Buscar</b-button>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Director class="mt-3" :colegio="filtro.colegio" v-if="filtro.colegio!=''"/>
    </Layout>
</template>